export const PRIZE_ITEM_ROTATE_DEG = 30
export const SPINNING_TIME = 11500
export const QUICK_SPINNING_TIME = 4500
export const INIT_ROTATE_DEG = 1800

